export class FILE_VIEW_DIALOG {
    static readonly ZOOM_IN = 'event:viewFileZoomIn';
    static readonly ZOOM_OUT = 'event:viewFileZoomOut';
    static readonly ROTATE_LEFT = 'event:viewFileRotateLeft';
    static readonly ROTATE_RIGHT = 'event:viewFileRotateRight';
    static readonly PREVIOUS = 'event:viewFilePrevious';
    static readonly NEXT = 'event:viewFileNext';
    static readonly CLOSE_IFRAME = 'event:viewFileCloseIframe';
    static readonly VIEW = 'event:viewFileView';
    static readonly IS_SHOW_NEXT_PRE = 'event:viewFileIsShowNextPre';
    static readonly IS_SHOW_NEXT = 'event:viewFileIsShowNext';
    static readonly IS_SHOW_PRE = 'event:viewFileIsShowPre';
    static readonly IS_SHOW_LOADING = 'event:viewFileIsShowLoading';
}